module.exports = __webpack_public_path__ + "img/biyo_logo.b6a13ed1.png";